import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Clone the request to add withCredentials
    const clonedRequest = req.clone({
      withCredentials: true,
    });

    // Pass the cloned request to the next handler
    return next.handle(clonedRequest);
  }
}

export const credentialsInterceptor = {
  provide: HTTP_INTERCEPTORS,
  useClass: CredentialsInterceptor,
  multi: true,
};
